import React from "react";

const PatternBackground = React.forwardRef(
  (
    {
      children,
      className = "",
      style,
      contentClassName = "",
      contentStyle,
      fullWidthOnMobile = false,
    },
    ref
  ) => (
    <div
      ref={ref}
      className={[
        "pattern-bg-root",
        fullWidthOnMobile && "pattern-bg-full-mobile",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{ position: "relative", ...style }}
    >
      <div
        className={[
          "relative z-[10] flex flex-col h-full",
          contentClassName,
        ]
          .filter(Boolean)
          .join(" ")}
        style={contentStyle}
      >
        {children}
      </div>
      <style>{`
        .pattern-bg-root {
          width: 100%;
          min-height: 60vh;
          background: #181526;
          color: #fff;
          position: relative;
          overflow: visible;
          box-sizing: border-box;
        }
        .pattern-bg-root::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.05);
          z-index: 0;
        }
        @media (max-width: 900px) {
          .pattern-bg-full-mobile {
            width: 100vw !important;
            left: 50% !important;
            margin-left: -50vw !important;
            max-width: none !important;
          }
        }
      `}</style>
    </div>
  )
);

export default PatternBackground;
